import { html } from '@resn/gozer-core';

import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import AssetsMixin from 'utils/loading/assets-mixin';

import Copy from '@resn/gozer-core/copy';
import Svg from 'component/svg';
import { autobind } from 'core-decorators';
import { getRoute } from 'utils/get-pages';
import { COLORS } from 'core/constants';

import BtnMain from 'component/btn-main';
import TextContentAnimation from 'component/text-content-animation';
import ScrollingText from 'component/sections/common/scrolling-text';

import './index.scss';
import { navigate } from 'utils/router-utils';

const title = 'Oxelead';

const template = ({ options }) => html`
    <section class="homeSoftware__feature--1  inverseColors" align="left">
        <div data-ui="inner" class="homeSoftware__featureInner  grid  maxWidth">
            <div data-ui="scrollingText" class="homeSoftware__scrollingText"></div>
            <div data-ui="imgWrap" class="homeSoftware__imgWrap"></div>

            <div data-ui="content" class="homeSoftware__content">
                <h3 data-ui="pretitle" class="homeSoftware__label  text-smallLabel">
                    ${Copy.get('home-module-4-pretitle')}
                </h3>
                <h1 data-ui="logo" class="homeSoftware__title">
                    ${title} ${Svg('oxefit-logo-inverse', 'homeSoftware__logo')}
                </h1>
                <h2 data-ui="subtitle" class="homeSoftware__subtitle  text-heading6">
                    ${Copy.get('home-module-4-subtitle')}
                </h2>
                <p data-ui="body" class="homeSoftware__body  text-body2">${Copy.get('home-module-4-paragraph')}</p>
            </div>
        </div>
    </section>
`;

@componentMixin(AssetsMixin())
@componentMixin(DomComponentMixin)
class HomeSoftwareFeature1 extends Component {
    props = {
        top: 0,
        bottom: 0,
    };

    options = {
        template,
    };

    assets = {
        graphic: 'static/images/pages/home/home-oxefit-graphic.svg#img',
        img: 'static/images/pages/home/home-oxefit-male.png#imgo',
    };

    onAssetsPreloaderComplete() {
        const graphic = this.assets.graphic.cloneNode();
        const img = this.assets.img.cloneNode();
        graphic.classList.add('homeSoftware__graphic');
        img.classList.add('homeSoftware__img');

        this.ui.imgWrap.appendChild(graphic);
        this.ui.imgWrap.appendChild(img);
    }

    async onSetup() {
        this.scrollingText = await new ScrollingText().setup({
            options: {
                appendTo: this.ui.scrollingText,
                overrideScroll: true,
                bgColor: COLORS.WHITE,
                inverseColors: true,
                className: 'feature1ScrollingText',
                lines: [
                    { text: Copy.get('home-messaging-apps-title-1'), color: COLORS.DARK_BLUE },
                    { text: Copy.get('home-messaging-apps-title-2'), color: COLORS.ORANGE },
                ],
            },
            props: {
                active: () => this.props.active,
            },
        });

        this.btn = await new BtnMain().setup({
            options: {
                appendTo: this.ui.content,
                onClick: this.onExploreXP1Click,
            },
            props: {
                text: Copy.get('home-module-4-button'),
            },
        });

        this.animatedContent = await new TextContentAnimation().setup({
            options: {
                el: this.ui.content,
            },
            props: {
                active: () => this.props.active,
            },
        });
    }

    calculateBounds(top) {
        this.scrollingText.resize();
        this.scrollingText.calculateBounds(top);
    }

    whileActive() {
        this.scrollingText.update();
    }

    @autobind
    onExploreXP1Click() {
        navigate(getRoute('oxefit'));
    }
}

export default HomeSoftwareFeature1;
